import { render, staticRenderFns } from "./OrganizationUpdateMdtDisease.vue?vue&type=template&id=236467c3&scoped=true"
import script from "./OrganizationUpdateMdtDisease.vue?vue&type=script&lang=js"
export * from "./OrganizationUpdateMdtDisease.vue?vue&type=script&lang=js"
import style0 from "./OrganizationUpdateMdtDisease.vue?vue&type=style&index=0&id=236467c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236467c3",
  null
  
)

export default component.exports